const MessageType = {
  SUCCESS: "success",
  WARNING: "warn",
  INFO: "info",
  ERROR: "error",
};

export default MessageType;
